export default __webpack_public_path__ + "static/media/misc-pantry1-1024w.ea972b60.png";